export const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const WEEK_AVERAGE = '4.348';
export const CREATION_DATE = 'creationDate';
export const DESC = 'desc';
export const PI = 3.14159;
export const MAX_EFFECTIF = 9999;
export const CONSUMABLE_SUP_PRIFIXE = ' SUP';